import Vue from 'vue';
import Vuex, { Store } from 'vuex';
import { editorViewInput } from './editor-view-input.store';
import { actions } from './editor-view.actions';
import { state } from './editor-view.constants';
import { mutations } from './editor-view.mutations';
import type { EditorViewState } from './editor-view.types';

Vue.use(Vuex);

export const editorViewStore = new Store<EditorViewState>({
  actions,
  mutations,
  modules: {
    editorViewInput,
  },
  state,
});
